<template>
<div class="link-button-wrapper">
  <div class="list media-list">
  <ul>
    <li v-if="actionType === 'PHONE' && isUserActionAllow">
      <a v-tel="linkURL" :style="linkStyle" class="item-link item-content external">
        <div class="item-media" v-if="icon !== ''">
          <img :src="iconUrl" width="30">
        </div>
        <div class="item-inner">
          <div class="item-title-row" :style="getStyle">
            <div class="item-title" >{{caption}}</div>
          </div>
        </div>
      </a>
    </li>
    <li v-else-if="actionType === 'EMAIL' && isUserActionAllow">
      <a v-mailto="linkURL" :style="linkStyle" class="external item-link item-content">
        <div class="item-media" v-if="icon !== ''">
          <img :src="iconUrl" width="30">
        </div>
        <div class="item-inner">
          <div class="item-title-row" :style="getStyle">
            <div class="item-title" >{{caption}}</div>
          </div>
        </div>
      </a>
    </li>
    <li v-else>
      <a :style="linkStyle" @click="onClick()" class="item-link item-content">
        <div class="item-media" v-if="icon !== ''">
          <img :src="iconUrl" width="30">
        </div>
        <div class="item-inner">
          <div class="item-title-row" :style="getStyle">
            <div class="item-title" >{{caption}}</div>
          </div>
        </div>
      </a>
    </li>
  </ul>
</div>
</div>
</template>
<script>
import {
  mapGetters
}
from 'vuex'
import { IsNullOrEmpty, showURL, HashCodeFromInt, IsDevSim, showExternalURL } from '@/modules/helper/index'
import { IsUserActionAllow } from "@/modules/helper/index";
import DeviceInfo from '@/modules/util/deviceInfo';
export default {
  props: {
    icon: {
      type: String,
      default: ''
    },
    isOutlined: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    captionFontFace: {
      type: String,
      default: ''
    },
    linkURL: {
      type: String,
      default: '#'
    },
    actionType: {
      type: String,
      default: 'NONE'
    }
  },
  computed: {
    ...mapGetters([
      'DesignSettings',
      'resource'
    ]),
    linkStyle() {
      return {
        'font-family': this.captionFontFace
      }
    },
    iconColor() {
      return this.DesignSettings.AppThemeColor
    },
    iconUrl() {
      let Url = ''
      let color = HashCodeFromInt(this.iconColor)
      color = color.replace('#', '%23')
      if (IsDevSim()) {
        if (this.icon.indexOf('/') !== -1) {
          let temp = this.icon.split('/')
          if (temp.length > 1) {
            let category = temp[0]
            let name = temp[1]
            let params = `category=${category}&name=${name}&outlined=${this.isOutlined}&subscriptionGuid=&color=${color}`
            Url = this.$store.getters.AppConfig.Urls.WebAPIURL + '/api/ImageServices/ColoredIcon?' + params
          }
        } else {
          let params = `category=&name=${this.icon}&outlined=${this.isOutlined}&subscriptionGuid=${this.$store.getters.AppConfig.Subscription_GUID}&color=${color}`
          Url = this.$store.getters.AppConfig.Urls.WebAPIURL + '/api/ImageServices/ColoredIcon?' + params
        }
      } else {
        Url = this.$store.getters.AppConfig.Urls.ContentAssetsBaseUrl + this.icon
      }
      return Url
    },
    getStyle() {
      let arrowColorNoHash = HashCodeFromInt(this.DesignSettings.AppThemeColor).substring(1)
      return `background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%2060%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%3E%3Cpath%20d%3D'm60%2061.5-38.25%2038.25-9.75-9.75%2029.25-28.5-29.25-28.5%209.75-9.75z'%20fill%3D'%23${arrowColorNoHash}'%2F%3E%3C%2Fsvg%3E")`
    },
    isUserActionAllow() {
      return IsUserActionAllow()
    }
  },
  methods: {
    showMessage() {
      let modalOptions = {
        title: this.resource.warningTitle,
        text: this.resource.warningMessage,
        buttonText: this.resource.closeBtn,
        downloadbuttonText: DeviceInfo.isAndroid
          ? this.resource.AndroidDownload
          : this.resource.AppleDownload,
        $f7: this.$f7
      };
      this.$showModal(modalOptions)
    },
    onClick() {
      if ((this.actionType === 'PHONE' || this.actionType === 'EMAIL') && !this.isUserActionAllow) {
        this.showMessage()
      } else if (this.actionType === 'WEBSITE' && !IsNullOrEmpty(this.linkURL)) {
        showURL(this.linkURL, this.DesignSettings.AppThemeColor, this.DesignSettings.AppThemeFontColor)
      } else if (this.actionType === 'EXTERNAL' && !IsNullOrEmpty(this.linkURL)) {
        showExternalURL(this.linkURL)
      } else if (this.actionType === 'APP_NAVIGATION' || this.actionType === 'HOME') {
        this.$f7.views.main.router.navigate(`/${this.linkURL}`)
      }
    }
  }
}
</script>
<style scoped>
  .link-button-wrapper {
    padding: 10px 0px!important;
  }
  .list {
    margin: 0px;
  }
  .item-title-row{
    padding-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/stacked-elements/content-control/LinkButton.vue